export default "__VITE_PUBLIC_ASSET__2bb8664b__"